import {Box, Stack, Typography, useTheme, Divider} from "@mui/material";
// import { tokens } from "../../theme";
import { styled, alpha } from "@mui/material/styles";
import AppealAvatar from "../../components/AppealAvatar";
import truncateString from "../../utils/trancate";
import { fTimeOrDate } from "../../utils/formatTime";


const StyledChatBox = styled(Box)(({ theme }) => ({
    "&:hover": {
        cursor: "pointer",
    },
}));

const AppealListElement = ({ appeal, provider, group, handleAppealClick, isSelected}) => {
    const theme = useTheme();
    // const colors = tokens(theme.palette.mode);

    const providerName = provider ? provider.name : "unknown"
    const groupName = group ? group.name : "unknown"
    const name = () => {
        switch(appeal.source_type) {
            case 'user':
                return appeal.crm_object.login ? appeal.crm_object.login : appeal.source
            case 'host': 
                return appeal.crm_object.performance ? appeal.crm_object.performance : appeal.source
            case 'network': 
                return appeal.crm_object.performance ? appeal.crm_object.performance : appeal.source
            case 'system_user': 
                return appeal.crm_object.performance ? appeal.crm_object.performance : appeal.source
            default: 
                return appeal.source
        }
    }

    return (
        <StyledChatBox
            onClick={() => {
                handleAppealClick(appeal);
            }}
            sx={{
                width: "100%",
                borderRadius: 1,
                backgroundColor: isSelected
                    ? theme.palette.mode === "light"
                        ? alpha(theme.palette.primary.main, 0.5)
                        : theme.palette.primary.main
                    : theme.palette.mode === "light"
                        ? "#fff"
                        : theme.palette.background.paper,
            }}
            p={1.5}
        >
            <Stack spacing={0.5}>
                <Typography variant="subtitle2">{truncateString(providerName + " - " + groupName, 40)}</Typography>
                <Divider />
                <Stack
                    direction="row"
                    alignItems={"center"}
                    justifyContent="space-between"
                >
                    <AppealAvatar type="element" provider={provider} group={group} appeal={appeal} truncatePerformance={40} truncateSubtitle={80}/>
                    {/* <Stack direction="row" spacing={2}>
                        {" "}
                        <AppealAvatar type={appeal.source_type} isOpen={appeal.is_open}/>
                        <Stack spacing={0.1}>
                            <Typography variant="subtitle2">{truncateString(name(), 40)}</Typography>
                            <Typography variant="caption">{truncateString(appeal.last_comment, 40)}</Typography>
                        </Stack>
                    </Stack> */}
                    <Stack spacing={2} alignItems={"center"}>
                        <Typography sx={{ fontWeight: 600 }} variant="caption">
                            { fTimeOrDate(appeal.updated_on) }
                        </Typography>
                        {/* <Badge
                            className="unread-count"
                            color="primary"
                            badgeContent={changed}
                        /> */}
                    </Stack>
                </Stack>
            </Stack>
        </StyledChatBox>
    );
};

export default AppealListElement;